export default {
  statusesCounters: (state) => state.statusesCounters,
};
